import { render, staticRenderFns } from "./SectionCard.vue?vue&type=template&id=ec2f2132&"
import script from "./SectionCard.vue?vue&type=script&lang=ts&"
export * from "./SectionCard.vue?vue&type=script&lang=ts&"
import style0 from "./SectionCard.vue?vue&type=style&index=0&id=ec2f2132&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports